"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAInfo = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const moment_1 = __importDefault(require("moment"));
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const functions_1 = require("../../../../server/functions");
const QnAInfoStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;

	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	width: 100%;

	.title-div {
		background-color: rgb(255, 255, 255);
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0) !important;
		border-width: 1px;
		padding: 9px;
		flex: 1;
		width: 100%;
		box-sizing: border-box;
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, "Noto Sans KR", sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 22px);
		letter-spacing: var(--b4-letter-spacing, -0.02em);
		font-weight: var(--b4-font-weight, 400);
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	gap: 12px;
`;
const tabletStyles = (0, styled_components_1.css) `
	gap: 12px;
	padding: 0px 0px 28px 0px;
	border-style: solid;
	border-color: var(--color-grey-c, #e6e8ed);
	border-width: 0px 0px 1px 0px;
`;
const desktopStyles = (0, styled_components_1.css) `
	gap: 24px;
	padding: 0px 0px 28px 0px;
	border-style: solid;
	border-color: var(--color-grey-c, #e6e8ed);
	border-width: 0px 0px 1px 0px;
`;
exports.QnAInfo = react_1.default.memo(({ item, isTeacher, handlerTitle, setIsImportance, isImportance, importance, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const titleRef = (0, react_1.useRef)(null);
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const [title, setTitle] = (0, react_1.useState)();
    const handlerChecked = (id, checked) => {
        if (item.private) {
            alert('비공개 문의는 필독으로 설정할 수 없습니다.');
            return;
        }
        (0, server_1.getQnaList)((0, functions_1.objectToQueryString)({ importance: true, root_only: true })).then(async (res) => {
            try {
                const { total_count, items } = res.result;
                const count = checked ? total_count + 1 : total_count - 1;
                if (count > 5 && checked) {
                    alert('필독은 5개까지만 선택 가능합니다.');
                    setIsImportance(false);
                    return;
                }
                setIsImportance(checked);
            }
            catch (error) { }
        });
    };
    const renderQnAInfo = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.register')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.InputElement, { className: "showText", type: "text", isDisable: true, value: item?.author_name, style: { backgroundColor: '#ffffff' } }))),
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.creation_time')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.InputElement, { className: "showText", type: "text", isDisable: true, value: (0, moment_1.default)(item?.creation_time).format('YYYY-MM-DD HH:mm'), style: { backgroundColor: '#ffffff', minWidth: '120px' } }))),
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.category')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.InputElement, { className: "showText", type: "text", isDisable: true, value: t(`supportRoom.${item?.category}`), style: { backgroundColor: '#ffffff' } }))),
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.answer_state')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.InputElement, { className: "showText", type: "text", isDisable: true, value: t(`supportRoom.${item?.status}`), style: { backgroundColor: '#ffffff' } })))));
    };
    (0, react_1.useEffect)(() => {
        // handlerTitle(title);
        if (titleRef && titleRef.current)
            titleRef.current.value = item?.title;
        setTitle(item?.title);
    }, [item?.title]);
    return (react_1.default.createElement(QnAInfoStyled, { "$isTablet": isTablet, "$isMobile": isMobile },
        isMobile ? renderQnAInfo() : react_1.default.createElement("div", { className: "field-short" }, renderQnAInfo()),
        react_1.default.createElement("div", { className: "field-global-001" },
            !isMobile && react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.title')),
            react_1.default.createElement("div", { className: "fext-field" },
                react_1.default.createElement("div", { className: "title-div" }, title),
                !item.private && isMobile && (react_1.default.createElement(common_1.CheckBoxElement, { id: "importance", title: "\uD544\uB3C5", checked: isImportance, handlerCheck: handlerChecked, className: "must-read" }))))));
});
